module.exports = __webpack_public_path__ + "img/1280x720-Dusk.53d2caed.jpg";